module.exports = __webpack_public_path__ + "img/icon-01.624cce8e.png";